import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

const PageLayoutSidebar = ({ children, className, ...rest }) => (
  <Box
    className={`PageLayoutSidebar ${className}`}
    sx={{
      maxWidth: ['100%', '100%', '240px'],
      mr: [0, 0, '40px'],
      mb: [4, 4, 0],
      pl: '16px',
      pr: ['16px', '16px', 0],
      ...(rest.sx || {}),
    }}
  >
    {children}
  </Box>
);

PageLayoutSidebar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object,
};

PageLayoutSidebar.defaultProps = {
  className: null,
  sx: {},
};

export default PageLayoutSidebar;
